import React from 'react';
export function Footer() {
  return <footer className="bg-[#050505] py-6 border-t border-gray-900" data-id="element-49">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-50">
        <p className="text-gray-600 text-xs sm:text-sm mb-2" data-id="element-51">
          © 2026 KIT COMPLETO GEOGRAFÍA LISTA ™
        </p>
        <div className="flex justify-center space-x-4 text-xs sm:text-sm text-gray-700" data-id="element-52">
          <span className="cursor-pointer hover:text-gray-400 transition-colors" data-id="element-53">
            Términos
          </span>
          <span className="cursor-pointer hover:text-gray-400 transition-colors" data-id="element-54">
            Privacidad
          </span>
          <span className="cursor-pointer hover:text-gray-400 transition-colors" data-id="element-55">
            Soporte
          </span>
        </div>
      </div>
    </footer>;
}